import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";
import { NoteCard } from "../note-card";
import { Spin } from "antd";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { EmptyDataLabel } from "components/empty-data-label";

export const NotesTreeView = ({
  notesData,
  loading,
  onEditNote,
  collapseOpen,
  handleDeleteNote,
  deleteNoteLoading,
}) => {
  const { translator } = useLanguageTranslator();
  return (
    <Spin spinning={loading}>
      <div
        className={`${styles.tree} ${notesData?.length < 1 ? styles.center : ""}`}
        style={{
          maxHeight: collapseOpen
            ? "calc(100dvh - 550px)"
            : "calc(100dvh - 200px)",
          minHeight: collapseOpen
            ? "calc(100dvh - 550px)"
            : "calc(100dvh - 200px)",
        }}
      >
        {notesData?.map((item, index) => (
          <div
            style={{ border: index === 0 && "none" }}
            key={item.noteId}
            className={`${styles.nodeWrapper} ${
              index % 2 === 0 ? styles.left : styles.right
            }`}
          >
            <div className={styles.content}>
              <ConditionalRenderer
                condition={index % 2 !== 0 && notesData?.length > 1}
              >
                <div className={styles.horizontalLine}></div>
              </ConditionalRenderer>
              <NoteCard
                data={item}
                onEditNote={onEditNote}
                handleDeleteNote={handleDeleteNote}
                deleteNoteLoading={deleteNoteLoading}
              />
              <ConditionalRenderer
                condition={index % 2 === 0 && notesData?.length > 1}
              >
                <div className={styles.horizontalLine}></div>
              </ConditionalRenderer>
            </div>
          </div>
        ))}
        <ConditionalRenderer condition={notesData?.length < 1}>
          <EmptyDataLabel />
        </ConditionalRenderer>
      </div>
    </Spin>
  );
};
